import { FC } from "react";
import { DateRangeInputProps } from "./types";
import { Row } from "../../containers";
import { usePopupStore, useThemeStore } from "../../../stores";
import { IconAnimation } from "../../animation";
import { CalendarIcon } from "../../../assets/icons";
import { Text } from "../../typography";
import { getDateStr } from "../../../utils";
import DateRangeInputPopup from "./DateRangeInputPopup";

const DateRangeInput: FC<DateRangeInputProps> = ({
  range,
  setRange = () => {},
  className = "",
  style = {},
  props,
}) => {
  const theme = useThemeStore((s) => s.theme);
  const setPopupBody = usePopupStore((s) => s.setPopupBody);

  const onClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    propsOnClick?: React.MouseEventHandler<HTMLDivElement>
  ): void => {
    if (propsOnClick) propsOnClick(e);
    setPopupBody(<DateRangeInputPopup range={range} setRange={setRange} />);
  };

  return (
    <Row
      style={{
        minHeight: 32,
        borderRadius: 15,
        border: `1px solid ${theme.icon}`,
        padding: "0 8px",
        cursor: "pointer",
        minWidth: 220,
        ...style,
      }}
      background={theme.background}
      gap={8}
      className={className}
      props={{ ...props, onClick: (e) => onClick(e, props?.onClick) }}
    >
      <IconAnimation
        Icon={CalendarIcon}
        onHoverColor={theme.primary}
        width={20}
        height={20}
        style={{ cursor: "pointer" }}
      />

      <Text color={theme.textOnBg}>از</Text>
      <Text color={theme.textOnBg}>{getDateStr(range.from)}</Text>

      <Text color={theme.textOnBg}>تا</Text>
      <Text color={theme.textOnBg}>{getDateStr(range.to)}</Text>
    </Row>
  );
};

export default DateRangeInput;
